// import { configureStore } from '@reduxjs/toolkit'
// import { reducerFunction } from './Redux/Reducers';
// import {persistStore, persistReducer} from 'redux-persist';
// import storage from 'redux-persist/lib/storage';


// const persistConfig = {
//   key: 'root',
//   storage,
// };

// const persistedReducer = persistReducer(persistConfig, reducerFunction);

// export const store = configureStore({
//   reducer: persistedReducer,
// })

// // export default store;
// export const persistor = persistStore(store)

import { configureStore } from '@reduxjs/toolkit';
import { reducerFunction } from './Redux/Reducers';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducerFunction);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false, // Disable ImmutableStateInvariantMiddleware
      serializableCheck: false, // Optionally disable SerializableStateInvariantMiddleware
    }),
});

// Persistor to enable redux-persist functionality
export const persistor = persistStore(store);
